export const coinMapping = {
  btc: "btc",
  bch: "bch",
  ltc: "ltc",
  dash: "dash",
  eth: "eth",
  etc: "etc",
  doge: "doge",
  usdt: "usdt",
  usdc: "usdc",
  ton: "ton",
};

export const INTERNAL_OPERATION_TYPES = [2, 54, 55];
export const TRANSACTION_TYPES = {
  0: "Any",
  1: "OperationTypes | Wallet top up",
  2: "OperationTypes | Coinhold top up",
  10: "OperationTypes | Referral payments to mining account",
  30: "OperationTypes | Withdraw from wallet",
  31: "OperationTypes | Withdraw from wallet (free)",
  42: "OperationTypes | Withdraw to card",
  51: "OperationTypes | Mining income to wallet",
  52: "OperationTypes | Referral payments to wallet",
  54: "OperationTypes | Coinhold promocode bonus",
  55: "OperationTypes | Coinhold referral accrual",
  56: "OperationTypes | Additional accrual",
  57: "OperationTypes | Exchange coin",
  66: "OperationTypes | Spending (P2P)",
  67: "OperationTypes | Top up (P2P)",
  69: "OperationTypes | Commission (P2P)",
  74: "OperationTypes | Offer creation (P2P)",
  75: "OperationTypes | Delisting from publication (P2P)",
  85: "OperationTypes | Shared Mining income",
  // 86: "OperationTypes | Withdraw to card",
  90: "OperationTypes | Withdraw from wallet (free)",
  91: "OperationTypes | Wallet top up",
  92: "OperationTypes | Mining income to wallet",
  93: "OperationTypes | Withdraw to email",
  94: "OperationTypes | Withdraw to card",
};

export const OPERATION_TYPES = {
  Any: [
    0, 1, 2, 9, 10, 30, 31, 42, 51, 52, 54, 55, 56, 57, 66, 67, 69, 74, 75, 85,
    86, 90, 91, 92, 93, 94,
  ],
  "OperationTypes | Wallet top up": [1, 9, 91, 93],
  "OperationTypes | Coinhold top up": [2],
  "OperationTypes | Referral payments to mining account": [10],
  "OperationTypes | Withdraw from wallet": [30, 90],
  "OperationTypes | Withdraw from wallet (free)": [31, 90],
  "OperationTypes | Withdraw to card": [42, 86, 94],
  "OperationTypes | Mining income to wallet": [51, 92],
  "OperationTypes | Referral payments to wallet": [52],
  "OperationTypes | Coinhold promocode bonus": [54],
  "OperationTypes | Coinhold referral accrual": [55],
  "OperationTypes | Additional accrual": [56],
  "OperationTypes | Exchange coin": [57],
  "OperationTypes | Spending (P2P)": [66],
  "OperationTypes | Top up (P2P)": [67],
  "OperationTypes | Commission (P2P)": [69],
  "OperationTypes | Offer creation (P2P)": [74],
  "OperationTypes | Delisting from publication (P2P)": [75],
  "OperationTypes | Shared Mining income": [85],
};
